import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment IndividualJtbdSurveyStep_org on Org {
      id
      userSurveyResponseWrapperErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on UserSurveyResponseWrapper {
          id
          userSurveyResponses {
            questionType
            responseType
            questionText
            responseText
            freeformResponse
          }
        }
      }
    }
  `,
};
